export default "__VITE_ASSET__b9My5iPd__"